
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[dynamicPage]",
      function () {
        return require("private-next-pages/[dynamicPage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[dynamicPage]"])
      });
    }
  